module.exports = __webpack_public_path__ + "static/media/help_form.655e28d6.pdf";